import { homeTypes } from './actions';
import { authTypes } from 'Containers/Auth/store/actions';
import { schedulerTypes } from 'Containers/Scheduler/store/actions';

const initialState = {
  home_statistic: {},
  queue: [],
  onboarding: {},
  wrapped_stats: {},
  homeStatLoading: false,
  queueLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case authTypes.SET_ACTIVE_SALON.SUCCESS:
      return {
        ...state,
        home_statistic: {},
        queue: [],
        homeStatLoading: false,
        queueLoading: false,
      };
    case homeTypes.GET_HOME_STAT.REQUEST:
      return {
        ...state,
        homeStatLoading: true,
      };
    case homeTypes.GET_HOME_STAT.SUCCESS:
      return {
        ...state,
        home_statistic: action.payload && typeof action.payload === 'object' ? action.payload : {},
        homeStatLoading: false,
      };
    case homeTypes.GET_HOME_STAT.FAILED:
      return {
        ...state,
        homeStatLoading: false,
      };
    case homeTypes.GET_QUEUE.REQUEST:
      // silent: refresh in background (es. dopo una rimozione), niente skeleton
      return action.options?.silent
        ? state
        : {
            ...state,
            queueLoading: true,
          };
    // Rimozione ottimistica dalla coda Home; il refresh dal server arriva subito dopo.
    case schedulerTypes.REMOVE_FROM_QUEUE.REQUEST: {
      const targetId = Number(action.payload?.idListaAttesa);
      if (!Number.isFinite(targetId) || !Array.isArray(state.queue)) return state;
      let changed = false;
      const nextQueue = state.queue.map((dayEntry) => {
        const list = dayEntry?.list;
        if (!Array.isArray(list)) return dayEntry;
        const filtered = list.filter((item) => Number(item?.idListaAttesa) !== targetId);
        if (filtered.length === list.length) return dayEntry;
        changed = true;
        return { ...dayEntry, list: filtered };
      });
      return changed ? { ...state, queue: nextQueue } : state;
    }
    case homeTypes.GET_QUEUE.SUCCESS:
      return {
        ...state,
        queue: action.payload,
        queueLoading: false,
      };
    case homeTypes.GET_QUEUE.FAILED:
      return {
        ...state,
        queueLoading: false,
      };
    case homeTypes.GET_ONBOARDING.SUCCESS:
      return {
        ...state,
        onboarding: action.payload
      };
    case homeTypes.GET_ONBOARDING.CLEAR:
      return {
        ...state,
        onboarding: {}
      };
    case homeTypes.GET_WRAPPED_STATS.SUCCESS:
      return {
        ...state,
        wrapped_stats: action.payload
      };
    default:
      return { ...state };
  }
};
